import React, { useRef, useState } from 'react'
import Header from './Header'
import Swiper2 from './Swiper2';
import { useNavigate } from 'react-router-dom';
import { FaRegClock } from 'react-icons/fa6';
import { FaCalendarAlt } from 'react-icons/fa';
import { IoLocationSharp } from 'react-icons/io5';
import Slidesmooth from './Slidsmooth';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer2 from './Footer2';

const Workshop = () => {
    const [formData, setFormData] = useState({
        Contact_Name: '',
        Contact_Email: '',
        Phone_Number: '',
        Contact_Message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Email format regex
        const phoneRegex = /^[0-9]{10}$/; // 10-digit phone format

        if (!formData.Contact_Name.trim()) {
            toast.error("Please enter your name.");
            return;
        }

        if (!formData.Contact_Email.trim()) {
            toast.error("Please enter your email.");
            return;
        }

        if (!emailRegex.test(formData.Contact_Email)) {
            toast.error("Please enter a valid email address.");
            return;
        }

        if (!formData.Phone_Number.trim()) {
            toast.error("Please enter your phone number.");
            return;
        }

        if (!phoneRegex.test(formData.Phone_Number)) {
            toast.error("Please enter a valid 10-digit phone number.");
            return;
        }

        if (!formData.Contact_Message.trim()) {
            toast.error("Please enter your message.");
            return;
        }


        try {
            await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/contact`, formData);
            toast.success('Thank you for contacting!');
            setFormData({
                Contact_Name: '',
                Contact_Email: '',
                Phone_Number: '',
                Contact_Message: ''
            });
        } catch (error) {
            toast.error('Failed to send message.');
            // console.error(error);
        }
    };

    const sliderRef = useRef(null);
    const navigate = useNavigate();

    // const onCollabForm = navigate('/collaborationform');
    const handleClick = () => {
        navigate('/collaborationform');
    };
    const scrollLeft = () => {
        sliderRef.current.scrollBy({ left: -303, behavior: 'smooth' });
    };
    const onContact = () => {
        navigate('/contact');
    }

    const scrollRight = () => {
        sliderRef.current.scrollBy({ left: 303, behavior: 'smooth' });
    };

    const images = [
        'IMG_2355.JPG', 'cate2.jpg', 'cate3.jpg', 'IMG_2707_Original.HEIC',
        'IMG_2355.JPG', 'EF5D7892-2F81-4790-9ECA-6619DE63777A.jpeg', 'cate3.jpg', 'IMG_8532.JPG',
        'IMG_2355.JPG', 'cate2.jpg', 'cate3.jpg', 'IMG_2707_Original.HEIC',
        'IMG_2355.JPG', 'EF5D7892-2F81-4790-9ECA-6619DE63777A.jpeg', 'cate3.jpg', 'IMG_8532.JPG'
    ];
    return (
        <>
            <Header />

            <div className="work1-main">
                <div className="container">
                    <div className="work1-inner-main">
                        <div className="work1-child">
                            <div className="work1-inner-child">
                                <img src="/assets/img/workshop/WS17.jpg" alt="" />
                            </div>
                        </div>
                        <div className="work1-child">
                            <div className="work1-inner-child">
                               
                                <p className='work1-one'>What it is all about</p>
                                <p className='work1-three'> Are you looking for an art workshop for your community group ? Unleash your inner  </p>
                                <p className='work1-three'>artist and join us to explore new media and techniques that speaks to you and take</p>
                                <p className='work1-three'>home a beautiful piece of art you created yourself.</p>

                                <p className='work1-three work1-gap'>We offer on demand workshops to kids as well as adults and seniors so , are you ready to craft?  </p>
                                {/* <p className='work1-three'></p> */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="work2-main">
                <div className="container">
                    <div className="work2-text">
                        <p className='work2-one' id='work2one' >Workshop Highlights</p>
                        {/* <p className='work2-two'>This workshop is designed for individuals who want to seriously understand the nature of inks and work along with me in a step-by-step guided way with all the right products. This workshop is designed for individuals who want to seriously understand the nature of inks and work along with me in a step-by-step guided way with all the right products. </p> */}
                    </div>
                </div>
            <Swiper2 type="workshop" />
            </div>
            <div className="work2-main exhibition-spacing">
                <div className="container">
                    <div className="work2-text">
                        <p className='work2-one'>Exhibitions Highlights</p>
                        {/* <p className='work2-two'>This workshop is designed for individuals who want to seriously understand the nature of inks and work along with me in a step-by-step guided way with all the right products. This workshop is designed for individuals who want to seriously understand the nature of inks and work along with me in a step-by-step guided way with all the right products. </p> */}
                    </div>
                </div>
            </div>
            <Swiper2 type="exhibition" />
              <div className="contect-page-main">
                <div className="container">
                    <div className="contect-wrapper">
                        <div className="contect-title" id="contacttitle">
                            <h2>Register Now</h2>
                        </div>
                        <form onSubmit={handleSubmit} className="contect-form">
                            <div className="contect-row">
                                <div className="contect-group">
                                    <label>Name</label>
                                    <input
                                        type="text"
                                        name="Contact_Name"
                                        value={formData.Contact_Name}
                                        onChange={handleChange}

                                    />
                                </div>
                                <div className="contect-group">
                                    <label>E-mail</label>
                                    <input
                                        type="email"
                                        name="Contact_Email"
                                        value={formData.Contact_Email}
                                        onChange={handleChange}

                                    />
                                </div>
                            </div>

                            <div className="contect-group">
                                <label>Number</label>
                                <input
                                    type="text"
                                    name="Phone_Number"
                                    value={formData.Phone_Number}
                                    onChange={handleChange}

                                />
                            </div>

                            <div className="contect-group">
                                <label>Message</label>
                                <textarea
                                    name="Contact_Message"
                                    value={formData.Contact_Message}
                                    onChange={handleChange}

                                />
                            </div>

                            <button type="submit" className="contect-submit-btn">SEND</button>
                        </form>
                    </div>
                </div>
            </div>


<Footer2/>
        </>
    )
}

export default Workshop;


